import { Controller } from "@hotwired/stimulus";
import Dropzone from "dropzone";

Dropzone.autoDiscover = false;

export default class extends Controller {
  static targets = [
    "dropzone",
    "form",
    "previews",
    "uploadButton",
    "dropzonePreviewTemplate",
    "uploadedPreviewTemplate",
    "toastContainerTemplate"
  ];

  connect() {
    const dropzonePreviewTemplate = this.dropzonePreviewTemplateTarget.innerHTML;
    const form = this.hasFormTarget ? this.formTarget : null;
    const formAction = form ? form.action : "/fallback-url";

    this.myDropzone = new Dropzone(this.dropzoneTarget, {
      url: formAction,
      paramName: "signin_sheet_image[image]",
      maxFiles: 1,
      acceptedFiles: "image/*",
      autoProcessQueue: false,
      addRemoveLinks: false,
      previewTemplate: dropzonePreviewTemplate,
      previewsContainer: this.hasPreviewsTarget ? this.previewsTarget : "#previews-container",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
      },
    });

    this.myDropzone.on("addedfile", (file) => {
      if (this.hasUploadButtonTarget) {
        this.uploadButtonTarget.disabled = false;
        this.uploadButtonTarget.classList.remove("disabled");
      }
    });

    this.myDropzone.on("removedfile", () => {
      if (this.myDropzone.files.length === 0 && this.hasUploadButtonTarget) {
        this.uploadButtonTarget.disabled = true;
        this.uploadButtonTarget.classList.add("disabled");
      }
    });

    if (form) {
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        if (this.myDropzone.getQueuedFiles().length > 0) {
          this.myDropzone.processQueue();
        } else {
          form.submit();
        }
      });

      this.myDropzone.on("success", (_, response) => {
        document.getElementById("signin_sheet_image").value = response.signed_id;

        const uploadedPreviewHTML = this.buildUploadedPreview(response);
        this.previewsTarget.insertAdjacentHTML("beforeend", uploadedPreviewHTML);

        const toastContainerHTML = this.buildToastContainer(response.notice);
        Turbo.renderStreamMessage(toastContainerHTML);

        setTimeout(() => {
          const modal = document.getElementById("upload-modal");
          if (modal) modal.classList.add("tw-hidden");
        }, 1500);
      });
    }
  }

  buildUploadedPreview(response) {
    const template = this.uploadedPreviewTemplateTarget.content.cloneNode(true);
    const img = template.querySelector("img");
    img.src = response.url;
    const filenameEl = template.querySelector(".filename");
    filenameEl.textContent = response.filename;

    return template.firstElementChild.outerHTML;
  }

  buildToastContainer(notice) {
    const template = this.toastContainerTemplateTarget.innerHTML;
    return template.replace("{{notice}}", notice || "");
  }
}
